var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.333,
    height: 85.333,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#124462",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405 510 c-19 -20 -18 -21 35 -75 l54 -55 24 23 c27 27 21 57 -19 94 -37 33 -71 38 -94 13z m80 -36 c27 -29 33 -54 12 -54 -16 0 -67 52 -67 68 0 21 30 13 55 -14z",
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 362 c-106 -107 -108 -110 -127 -183 -11 -41 -20 -75 -20 -76 0 0 32 7 72 17 70 19 74 21 185 132 l113 113 -52 52 c-29 29 -55 53 -58 53 -3 0 -54 -49 -113 -108z m51 -39 c-72 -72 -98 -92 -112 -87 -15 6 -1 24 80 105 78 78 101 96 112 87 11 -9 -5 -29 -80 -105z m129 51 c4 -11 -23 -45 -88 -110 -86 -86 -95 -93 -103 -74 -8 18 3 34 80 111 49 49 92 89 97 89 4 0 10 -7 14 -16z m-231 -179 c28 -28 26 -40 -10 -47 -36 -7 -47 4 -40 40 8 39 17 40 50 7z",
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5995d7e1912bc4575ecce97cc40d3564.svg";
export { ForwardRef as ReactComponent };